export default __webpack_public_path__ + "static/font-13348e1132cbca17fa5ba3b108defc89.woff2";